  export class User {
    public id: number;
    public idToken: String
    public email: string;
    public user: string;
    public first_name: string;
    public last_name: string;
    public admin: boolean;
    constructor() { }

    
    //possible new user
    public userID: number;
    public userName: string;
    public password: string;
    public firstName: string;
    public lastName: string;
    // public email: string;
    public phone: string;
    public fax: string;
    public country: string;
    public city: string;
    public culture: string;
    public profileID: number;
    public created: string;
    public createdBy: string;
    public lastUpdate: string;
    public lastUpdateBy: string;
    public entidadBancaria: string;
    public operatorId: string;
    public loginKey: string;
    public office: string;
    public commerceList: string;
    public enrollment: boolean;   
  }